import { OrderStatus, OrderWhereInput, QueryMode } from "/@/generated/graphql";

/** Chaque mot saisi doit se retrouver dans le prénom, le nom du patient ou la référence. */
export const buildOrderSearchWhere = (search: string): OrderWhereInput => ({
  status: {
    not: {
      equals: OrderStatus.Draft,
    },
  },
  AND: search
    .trim()
    .split(" ")
    .filter(Boolean)
    .map(word => ({
      OR: [
        {
          patient: {
            is: { firstName: { contains: word, mode: QueryMode.Insensitive } },
          },
        },
        {
          patient: {
            is: { lastName: { contains: word, mode: QueryMode.Insensitive } },
          },
        },
        { orderReference: { contains: word, mode: QueryMode.Insensitive } },
      ],
    })),
});
